import { useAsiAccessDecision } from '#pplx/frontend/apps/ask/hooks/computer-access-hooks/useAsiAccessDecision.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
/**
 * Returns access state for the Computer feature.
 *
 * Enterprise users are gated by the backend access decision, which resolves
 * permissions-platform product entitlements and the org-wide Computer switch.
 *
 * Consumer users require Max subscription or a positive backend access decision.
 */
export function useCanUseComputerState({ enabled = true, } = {}) {
    const { data: accessDecision, isLoading: accessDecisionLoading, isError, } = useAsiAccessDecision({ enabled });
    const { isMax, isEnterprise } = useIsSubscribed();
    // Fail open on error — let backend credits check handle gating
    if (isError) {
        return { canUseComputer: true, isLoading: false };
    }
    if (isEnterprise) {
        if (accessDecision != null) {
            return {
                canUseComputer: accessDecision.can_use_computer,
                isLoading: accessDecisionLoading,
            };
        }
        return { canUseComputer: false, isLoading: accessDecisionLoading };
    }
    if (accessDecision != null) {
        return {
            canUseComputer: accessDecision.can_use_computer,
            isLoading: accessDecisionLoading,
        };
    }
    return { canUseComputer: isMax, isLoading: accessDecisionLoading };
}
/**
 * Returns whether the current user has access to the Computer feature.
 */
export function useCanUseComputer({ enabled = true } = {}) {
    return useCanUseComputerState({ enabled }).canUseComputer;
}
//# sourceMappingURL=useCanUseComputer.js.map